'use strict'

const xConsume = 'x-consume'
const xResponseDescription = 'x-response-description'
const xExamples = 'x-examples'

module.exports = {
  xConsume,
  xResponseDescription,
  xExamples
}
